import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ConsumoRoutingModule } from './consumo-routing.module';
import { ConsumoInserirComponent } from './consumo-inserir/consumo-inserir.component';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ConsumoRoutingModule
  ]
})
export class ConsumoModule { }
